<template>
    <div v-show="isShow" class="stampBoard" :style="{ top: top + 'px', left: left + 'px' }">
        <!-- 標題 -->
        <div>
            <span class="stamp_title_text">印章</span>
            <!-- 拖曳區 -->
            <svg ref="stampTitleText" class="move" :style="{ transform: 'scale(' + scale + ')' }">
                <rect fill-opacity="0" class="moveable" @pointerdown="startDrag($event, $refs.stampTitleText)" width="650" height="65" x="0" y="0"></rect>
            </svg>
        </div>
        <!-- 圖片列表 -->
        <div class="stamp_image_list">
            <div v-if="currentPageTag == 'SymbolTag'" class="symbol_image_area">
                <img
                    v-for="(imgUrl, index) in symbolImgList"
                    :key="index"
                    class="stamp_image"
                    :class="[{ selected: currentImgIndex == index }]"
                    :src="changeUrl(imgUrl)"
                    @pointerdown.stop="selectStamp(imgUrl, index)"
                />
            </div>
            <div v-if="currentPageTag == 'NumberTag'" class="number_image_area">
                <img
                    v-for="(imgUrl, index) in numberImgList"
                    :key="index"
                    class="stamp_image"
                    :class="[{ selected: currentImgIndex == index }]"
                    :src="changeUrl(imgUrl)"
                    @pointerdown.stop="selectStamp(imgUrl, index)"
                />
            </div>
        </div>
        <!-- 工具列 -->
        <div class="stamp_bottom_line">
            <img class="stamp_close_btn" :src="closeBtnUrl" @click.stop="closeBoard" />
            <!-- 標籤列表 -->
            <div class="page_tag_area">
                <div
                    v-for="(element, index) in pageTagKey"
                    :key="index"
                    class="stamp_page_tag"
                    :class="[{ selected: currentPageTag == element }]"
                    @pointerdown="changePageTag(element)"
                >
                    <span class="page_tag_text">{{ pageTagValue[index] }}</span>
                </div>
            </div>
            <img class="stamp_close_btn" :style="{ 'justify-self': 'flex-end' }" :src="closeBtnUrl" @pointerup.stop="closeBoard" />
        </div>
    </div>
</template>

<script>
import { PageTag, NumberImgList, SymbolImgList } from "@/js/stamp/stamp_data";
import DEFINE from "@/js/painter/define";
import PainterProxy from "@/js/painter/proxy";
import DragElem from "../DragElem.vue";
import { store } from "@/store";
import { TOOLS } from "@/js/toolbar/tools";
import CursorStyle from "@/js/cursor/cursor_style";
import { focusStore } from "../../js/store/nowFocusStore";

export default {
    name: "StampBoard",
    data: function () {
        return {
            isShow: false,
            /** 關閉按鈕圖片 */
            closeBtnUrl: require("../../assets/art/white_board/btn_close.svg"),
            /** 現在頁籤 */
            currentPageTag: null,
            /** 現在選取的圖片 */
            currentImgIndex: null,
            /** 符號圖片列表 */
            symbolImgList: SymbolImgList,
            /** 數字圖片列表 */
            numberImgList: NumberImgList,
        };
    },
    mixins: [DragElem],
    mounted() {
        this.currentPageTag = this.pageTagKey[0];
        this.currentImgIndex = 0;
        this.top = store.baseSize.height * 0.92 - 390;
        this.left = (store.baseSize.width - 650) / 2;
        store.stampCustomPage = this.currentPageTag;
        store.stampCustomIndex = this.currentImgIndex;
    },
    computed: {
        pageTagKey() {
            return Object.keys(PageTag);
        },
        pageTagValue() {
            return Object.values(PageTag);
        },
        currentStampList() {
            switch (this.currentPageTag) {
                case "SymbolTag":
                    return this.symbolImgList;
                case "NumberTag":
                    return this.numberImgList;
            }
        },
    },
    methods: {
        closeBoard() {
            if(!this.isShow) return;
            this.isShow = false;
            const type = focusStore.getNowPageItemControl().type;
            console.log("type:", type)
            switch(type) {
                case "mainPage":
                    store.clearDisabledTools();
                    break;
                case "graphicBoard":
                    store.setGraphicDisabledTools();
                    break;
                default:
                    store.clearDisabledTools();
                    break;
            }
            PainterProxy.getInstance().changeTool(null);
        },
        /**
         * 選取貼圖
         * @param {*} imgUrl
         * @param {*} imgIndex
         */
        selectStamp(imgUrl, imgIndex) {
            // 選圖
            PainterProxy.getInstance().changeTool(DEFINE.TOOLS.STAMP);
            PainterProxy.getInstance().setStampImg(imgUrl);
            // 切換印章
            store.nowTool = TOOLS.STAMP.TOOL;
            CursorStyle.getInstance().setCurrentCursor();
            this.currentImgIndex = imgIndex;
            store.stampCustomIndex = this.currentImgIndex;
        },
        /**
         * 選取頁籤
         * @param {*} element
         */
        changePageTag(element) {
            this.currentPageTag = element;
            this.currentImgIndex = 0;
            store.stampCustomPage = element;
            PainterProxy.getInstance().setStampImg(this.currentStampList[this.currentImgIndex]);
        },
        getUserCustom() {
            this.currentPageTag = store.stampCustomPage;
            this.currentImgIndex = store.stampCustomIndex;
        },
        changeUrl(imgUrl) {
            return "./image/stamp/" + imgUrl;
        },
    },
    watch: {
        isShow: {
            handler: function (newValue) {
                if (newValue) {
                    store.setStampDisabledTools();
                    PainterProxy.getInstance().changeTool(DEFINE.TOOLS.STAMP);
                    PainterProxy.getInstance().setStampImg(this.currentStampList[this.currentImgIndex]);
                }
            },
        },
    },
};
</script>

<style>
.stampBoard {
    position: fixed;
    width: 650px;
    height: 390px;
    display: grid;
    grid-template-rows: 1fr 4fr 1fr;
    align-items: center;
    background-color: #0850a8;
    border-radius: 10px;
    z-index: var(--z-index-stamp-board);
}

.stamp_title_text {
    color: #ffffff;
    font-size: 30px;
    font-weight: bold;
    font-family: 微軟正黑體;
}

.move {
    position: absolute;
    width: 650px;
    height: 390px;
    top: 0px;
    left: 0px;
    pointer-events: none;
}

.moveable {
    pointer-events: fill;
    cursor: move;
}

.stamp_image_list {
    background-color: #ffffff;
    height: 100%;
    margin: 0px 10px;
    border-radius: 10px;
}

.symbol_image_area {
    display: grid;
    grid-template-columns: repeat(8, 1fr);
    align-self: center;
    padding: 10px;
    grid-gap: 5px;
}

.number_image_area {
    display: grid;
    grid-template-columns: repeat(10, 1fr);
    align-self: center;
    padding: 10px;
    grid-gap: 5px;
}

.stamp_image {
    height: 48px;
    margin: auto;
    cursor: pointer;
    padding: 1px;
    border: 3px solid #00000000;
}

.stamp_image.selected {
    border: 3px solid #000000;
}

.stamp_bottom_line {
    display: grid;
    grid-template-columns: 1fr 10fr 1fr;
    height: 100%;
    margin: 0px 10px;
}

.page_tag_area {
    display: flex;
    padding: 0px 5px;
}

.stamp_page_tag {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 80px;
    height: 80%;
    margin-top: 0px;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    background-color: #999999;
    cursor: pointer;
}

.stamp_page_tag.selected {
    margin-top: -3px;
    background-color: #ffffff;
}

.page_tag_text {
    font-size: 20px;
    font-weight: bold;
}

.stamp_close_btn {
    width: 40px;
    aspect-ratio: 1/1;
    padding-top: 5px;
    cursor: pointer;
}
</style>
